import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=67f5d75f&scoped=true&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=67f5d75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5d75f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f5d75f')) {
      api.createRecord('67f5d75f', component.options)
    } else {
      api.reload('67f5d75f', component.options)
    }
    module.hot.accept("./TopNavbar.vue?vue&type=template&id=67f5d75f&scoped=true&", function () {
      api.rerender('67f5d75f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/TopNavbar.vue"
export default component.exports